module.exports = "<span\n  [hidden]=\"!hasApiValidationError()\"\n  class=\"invalid-field-message\"\n>\n  {{ getApiValidationError() }}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/shared/api-validation/api-validation-error/api-validation-error.component.html
// module id = ../../../../../src/app/shared/api-validation/api-validation-error/api-validation-error.component.html
// module chunks = main